import menusStore from './menusStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.menus) {
      store.registerModule(['base', 'menus'], menusStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'menus']);
  },
};
